import { Component, Input, OnInit, inject } from '@angular/core';
import { AddressProducts, ClearingAccount } from '@mwe/models';
import { getCategoriesForClearingAccount, getClearingAccountDuePaymentSum, isArrayWithMinOneItem } from '@mwe/utils';
import { FindPaymentSolutionLogic } from '@mwe/services';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslateDirective } from '@ngx-translate/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { EuroCurrencyPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-products-group-unpaid-invoice-notification',
  templateUrl: './products-group-unpaid-invoice-notification.component.html',
  imports: [BasicCardComponent, TranslateDirective, ButtonComponent, EuroCurrencyPipe],
})
export class ProductsGroupUnpaidInvoiceNotificationComponent implements OnInit {
  private findPaymentSolutionLogic = inject(FindPaymentSolutionLogic);

  @Input() unpaidInvoices: ClearingAccount[];
  @Input() addressProducts: AddressProducts;
  @Input() isNavigateBtnVisible = true;
  amount: number;

  ngOnInit(): void {
    this.amount = getClearingAccountDuePaymentSum(this.unpaidInvoices);
  }

  showUnpaidInvoices(): void {
    const clearingAccountsWithUnpaidInvoices = this.unpaidInvoices.filter(ui => isArrayWithMinOneItem(ui?.unpaidInvoices?.offeneZahlungen));
    if (clearingAccountsWithUnpaidInvoices.length === 1) {
      this.findPaymentSolutionLogic.navigateToUnpaidInvoices(
        getCategoriesForClearingAccount(clearingAccountsWithUnpaidInvoices[0], this.addressProducts.products),
        clearingAccountsWithUnpaidInvoices[0],
        this.addressProducts.address,
      );
      return;
    }

    this.findPaymentSolutionLogic.navigateToSelection(this.unpaidInvoices, this.addressProducts);
  }
}
